import MainLayout from "@/components/layout/admin/MainLayout.vue";
import Select2Multiple from 'v-select2-multiple-component';
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import axios from "axios";
import store from '../../store';
import {
    required,maxLength
} from "vuelidate/lib/validators";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
    name: "gradingCreate",
    components: {
        MainLayout,
        Select2Multiple,
        flatPickr,
        Loading
    },

    data() {
        return {
            isLoading: false,
            classData: {},
            selectedClass: 0,
            classArr: [],
            subjectArr: [],
            studentNameArr: [],
            examNameArr: [],
            academic_year: '',
            academicYear: '',
            class_id: '',
            remark: '',
            gradingSelected: 0,
            exam_id: '',
            student_id: 0,
            subject_id: '',
            academicYearArr: null,
            gradingArr: null,
            submitted: false,
            autoGrading: false,
            marks: [],
            grades: [],
            comment: [],
            mark_ErrMsg: [],
            grade_ErrMsg: [],
            subject_ErrMsg: '',
            comment_msg: [],
            msgCount: 0,
            id: 0,
            cmt: 0,
            cmtCount: 0,
            isError: false,
            noStudentMsg:'',
            noExamMsg: '',
            VALID_GRADES: '',
            gradingBy: 'student',
        };
    },

    validations: {
        class_id: {
            required
        },
        academic_year: {
            required
        },
        student_id: {
            required
        },
        subject_id: {
            required
        },
        exam_id: {
            required
        },
        comment: {
            $each: {
                maxLength: maxLength(1000)
            }
        }
    },

    methods: {
      getCurrentPeriodList() {
        axios.get('/period/getCurrentPeriodList', {
          params: {
            campus_id: store.state.user.campus_id,
          }
        })
          .then(res => {
            let $defaultSelectOption = [{
              'id': 0,
              'text': 'Select Academic Year'
            }];
            this.academicYearArr = $defaultSelectOption.concat(res.data);
            this.isLoading = false;
          })
          .catch((error) => {
            if (error.response.status == 401) {
              this.$store.commit('logout');
              window.location.replace('login');
            }
            this.isLoading = false;
          });
      },
        
        changeEvent(val, fieldName) {
            this.submitted = false;
            this.$set(this, fieldName, val);
            switch (fieldName) {
                case "academic_year":
                   this.isLoading = true;                 
                   this.classArr = [];
                   this.subjectArr = [];
                   this.studentNameArr = [];
                   this.mark_ErrMsg= [];
                   this.grade_ErrMsg= [];
                   this.examNameArr = [];
                   this.subject_ErrMsg= '';
                   this.marks = [];
                   this.grades = [];
                   this.comment = [];
                   this.comment_msg= [];
                   this.subject_id = -1;
                   this.student_id = 0;
                   this.class_id = 0;
                   this.exam_id = '';
                   this.selectedClass = 0;
                    this.getClass(val);
                    break;
                
                case "class_id": 
                   this.isLoading = true;
                   this.subjectArr = [];
                   this.studentNameArr = [];
                   this.mark_ErrMsg= [];
                   this.grade_ErrMsg= [];
                   this.examNameArr = [];
                   this.subject_ErrMsg = '';
                   this.marks = [];
                   this.grades = [];
                   this.exam_id = '',
                   this.comment = [];
                   this.comment_msg = [];
                   this.subject_id = -1;
                   this.student_id = 0;
                   this.getStudentName(val);
                   this.getExamforClass(val);
                    break;

                case 'student_id':
                    this.marks = [];
                    this.grades = [];
                    this.comment = [];
                    this.comment_msg = [];
                    break;

                case 'exam_id':
                  this.subject_id = '';
                  this.handleExamChange(val);
                  break;

                case 'subject_id':
                  this.resetData();
                break;
            }
        },

        getClass(academic_year) {
            axios.get("class/classList/" + academic_year, {
                    params: {
                        campus_id: store.state.user.campus_id
                    }
                })
                .then(res => {
                    let $defaultSelectOption = [{
                        'id': 0,
                        'text': 'Select Class',
                        'subjects': [],
                    }];
                    this.classArr = $defaultSelectOption.concat(res.data);
                    this.isLoading = false;
                }).catch((error) => {
                    if (error.response.status == 401) {
                        this.$store.commit('logout');
                        window.location.replace('login');
                    }
                    this.isLoading = false;
                });
        },

        changeEventSubject(val, index) {
            let fieldName = val.target.name;
            let errMsg = (fieldName == 'mark') ? this.mark_ErrMsg : this.grade_ErrMsg;
            if (val === null || val === '') {
                errMsg[index] = 'Please Enter Student ' + fieldName;
            } else {
                errMsg[index] = '';
            }
        },
        
        getExamforClass(class_id) {
          axios.get("exam/examList", {
            params: {
              class_id: class_id,
              campus_id: store.state.user.campus_id
            }
          })
            .then(res => {
              if (res.data.length > 0) {
                let $defaultSelectOption = [{
                  'id': 0,
                  'text': 'Select Exam'
                }];
                this.examNameArr = $defaultSelectOption.concat(res.data);
                this.noExamMsg = '';
                this.isLoading = false;
              } else {
                this.examNameArr = [];
                this.noExamMsg = 'No Exam for this class.'
                this.isLoading = false;
              }
            }).catch((error) => {
              if (error.response.status == 401) {
                this.$store.commit('logout');
                window.location.replace('login');
              }
              this.isLoading = false;
            });
        },

        getStudentName($classId) {
            axios.get("student/getStudentName/" + $classId, {
                    params: {
                    campus_id: store.state.user.campus_id
                    }
                 })
                 .then(res => {
                  if (res.data.length > 0) {
                    let $defaultSelectOption = [{
                        'id': 0,
                        'text': 'Select Student Name'
                    }];
                    this.studentNameArr = $defaultSelectOption.concat(res.data);
                    this.noStudentMsg = '';
                    this.isLoading = false;
                  } else {
                    this.studentNameArr = [];
                    this.noStudentMsg = 'No student for this class.'
                    this.isLoading = false;
                  }
                }).catch((error) => {
                    if (error.response.status == 401) {
                       this.$store.commit('logout');
                       window.location.replace('login');
                    }
                    this.isLoading = false;
                });
        },

        getSubjectByClassId($classId) {
            axios
                .get("/class/subjectByClassId/" + $classId, {
                    params: {
                        campus_id: store.state.user.campus_id,
                        acd_year_id: this.academic_year
                    }
                })
                .then((response) => {
                    if (response.data && response.data.subjectArr.length > 0) {
                        this.subjectArr = response.data.subjectArr[0];
                    }
                    this.isLoading = false;
                })
                .catch((error) => {
                    if (error.response.status == 401) {
                        this.$store.commit('logout');
                        window.location.replace('login');
                    }
                    this.isLoading = false;
                    console.log("Subject API Error", error);
                });
        },

        async getValidGrades() {
            try {
              const response = await axios.get('grading/valid-grades');
              if (response) {
                this.VALID_GRADES = response.data;  
              }
            } catch (error) {
              if (error.response.status == 401) {
                this.$store.commit('logout');
                window.location.replace('login');
              }
              this.isLoading = false;
            }
        },

        confirmRegister() {
          this.msgCount = 0; 
          this.cmtCount = 0;
          this.submitted = true;
          this.isLoading = true;

          this.gradingRows.forEach((item, index) => {
            this.$set(this.mark_ErrMsg, index, '');
            this.$set(this.grade_ErrMsg, index, '');
            this.$set(this.comment_msg, index, '');

            let commentLength = this.comment[index] ? this.comment[index].length : 0;
            if (commentLength > 1000) {
              this.comment_msg[index] = 'Grading comment cannot be exceeded more than 1000 characters';
              this.cmtCount++;
            }
            let currentMark = this.marks[index];
            let hasMark = (currentMark !== undefined && currentMark !== '' && currentMark !== null);
            if (hasMark) {
              if (currentMark < 0 || currentMark > 100) {
                this.mark_ErrMsg[index] = "Mark must be between 0 and 100";
                this.msgCount++;
              }
            }

            let currentGrade = this.grades[index] ? this.grades[index].toString().trim() : '';
            let hasGrade = (currentGrade !== '');

            if (hasGrade) {
              if (currentGrade.length > 10) {
                this.grade_ErrMsg[index] = "Grade must be at most 10 characters.";
                this.msgCount++;
              } else if (this.VALID_GRADES && !this.VALID_GRADES.includes(currentGrade)) {
                this.grade_ErrMsg[index] = `Grade "${currentGrade}" is not valid.`;
                this.msgCount++;
              }
            }

            if (!this.autoGrading) {
              if (!hasMark && !hasGrade) {
                this.mark_ErrMsg[index] = "Either mark or grade is required.";
                this.grade_ErrMsg[index] = "Either mark or grade is required.";
                this.msgCount++;
              }
            }
          });
          if (this.autoGrading) {
            const hasAnyMark = this.marks.some(mark => mark !== '' && mark !== null);
            if (!hasAnyMark) {
              this.isLoading = false;
              this.$notification.error("At least one mark is required for auto-grading.");
              return;
            }
          }
          this.Loading = true;
          this.register();
        },

      register() {
        const gradingData = this.gradingRows.map((item, index) => {
          return {
            student_id: this.gradingBy === 'subject' ? parseInt(item.id) : parseInt(this.student_id),
            subject_id: this.gradingBy === 'student' ? parseInt(item.id) : parseInt(this.subject_id),

            mark: this.marks[index],
            grade: this.grades[index],
            comment: this.comment[index]
          };
        });
        const request = {
          academic_year: parseInt(this.academic_year),
          class_id: parseInt(this.class_id),
          exam_id: parseInt(this.exam_id),
          autoGrading: this.autoGrading ? 1 : 0,
          gradingBy: this.gradingBy,
          student_id: this.student_id ? parseInt(this.student_id) : null,
          subject_id: this.subject_id ? parseInt(this.subject_id) : null,
          grading_data: gradingData
        };

        axios.post("/grading/create", request, {
          headers: {
            'Content-Type': 'application/json',
          }
        })
        .then(response => {
          if (response.data.status == 200) {
            this.isLoading = false;
            this.$notification.success("Grading Added Successfully", {
              timer: 3,
              position: "bottomCenter"
            });
            this.$router.push({
              name: "gradingList"
            });
          }
          else if (response.data.success == false) {
            this.isLoading = false;
            this.$notification.error(response.data.message, {
              timer: 3,
              position: "bottomCenter",
            });
          } else {
            this.isLoading = false;
            this.$notification.error("Something went wrong", {
              timer: 3,
              position: "bottomCenter",
            });
          }
        })
        .catch(error => {
          if (error.response && error.response.status === 409) {
            this.$notification.error(error.response.data.message || "Grading data already exists.", {
              timer: 3,
              position: "bottomCenter",
            });
          } else if (error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          this.isLoading = false;
          console.log("Grading Create API Error", error.errors);
        });
      },

      showList() {
        this.$router.push({
          path: "/grading/list"
        });
      },

      handleExamChange(val) {
        if (!val || val == 0) {
          this.subjectArr = [];
          return;
        }
        const selectedExam = this.examNameArr.find(e => e.id == val);
        if (selectedExam && selectedExam.subjects) {
          this.subjectArr = selectedExam.subjects.map(s => ({
            id: s.id,
            text: s.subject_name
          }));
        }
        this.isLoading = false;
      },

      resetData() {
        this.marks = [];
        this.grades = [];
        this.comment = [];
        this.mark_ErrMsg = [];
        this.grade_ErrMsg = [];
        this.comment_msg = [];
        this.subject_ErrMsg = '';
      },
    },

    computed: {
      gradingRows() {
        if (!this.gradingBy) return [];

        if (this.gradingBy === 'student') {
          return (this.student_id != 0 && this.student_id != null) ? this.subjectArr : [];
        } else {
          return (this.subject_id != '' && this.subject_id != -1) ?
            this.studentNameArr.filter(s => s.id != 0) : [];
        }
      }
    },

    mounted() {
        this.isLoading = true;
        this.getCurrentPeriodList();
        this.getValidGrades();
    },
};
